/* eslint-disable no-unused-vars */

import React, { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import { TextField } from "@mui/material";
import { UserType } from "../../types/user";
import { FiUsers } from "react-icons/fi";
import { inputStyles } from "../ModalComponents/MeetingModal/styles/inputStyles";
// import { FormattedMessage } from "react-intl";
// import messages_en from "./translations/en.json";
// import messages_fr from "./translations/fr.json";

type UserListType = {
    user: UserType;
    randomColor?: string;
};

interface UserSearchProps {
    usersList: UserType[] | null;
    sharedCalUsersList: UserListType[] | null;
    handleSelect: (user: string) => void;
    placeholder: string;
}

// usersList : the pool of users that can be searched from the meeting modal

const UserSearch: React.FC<UserSearchProps> = ({
    usersList,
    sharedCalUsersList,
    handleSelect,
    placeholder,
}) => {
    const intl = useIntl();
    const [searchTerm, setSearchTerm] = useState<string>("");
    const [filteredUsers, setFilteredUsers] = useState<
        UserListType[] | UserType[]
    >([]);
    const [showSuggestions, setShowSuggestions] = useState<boolean>(false);

    useEffect(() => {
        if (searchTerm === "") {
            setFilteredUsers([]);
            setShowSuggestions(false);
        } else {
            setShowSuggestions(true);
        }
    }, [searchTerm]);

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        setSearchTerm(e.target.value);
        setShowSuggestions(true);
    };

    const selectUser = (userId: string) => {
        handleSelect(userId);
        setShowSuggestions(false);
        setSearchTerm("");
    };

    useEffect(() => {
        if (searchTerm === "") {
            setFilteredUsers([]);
        } else {
            if (sharedCalUsersList) {
                const filtered = sharedCalUsersList.filter(
                    (el) =>
                        el.user.first_name
                            .toLowerCase()
                            .includes(searchTerm.toLowerCase()) ||
                        el.user.last_name
                            .toLowerCase()
                            .includes(searchTerm.toLowerCase()) ||
                        el.user.user_id.toString().includes(searchTerm)
                );
                setFilteredUsers(filtered);
            } else if (usersList) {
                const filtered = usersList.filter(
                    (user) =>
                        user.first_name
                            .toLowerCase()
                            .includes(searchTerm.toLowerCase()) ||
                        user.last_name
                            .toLowerCase()
                            .includes(searchTerm.toLowerCase()) ||
                        user.user_id.toString().includes(searchTerm)
                );
                setFilteredUsers(filtered);
            }
        }
    }, [searchTerm, sharedCalUsersList]);

    return (
        <div className="w-full relative">
            <TextField
                variant={sharedCalUsersList ? "outlined" : "filled"}
                fullWidth
                label={intl.formatMessage({ id: placeholder })}
                value={searchTerm}
                onChange={(e) => handleChange(e)}
                onBlur={() => setShowSuggestions(false)} // Hide suggestions on blur
                onFocus={searchTerm !== "" && (() => setShowSuggestions(true))} // Show suggestions on focus
                sx={inputStyles}
                InputProps={{
                    style: {
                        fontSize: sharedCalUsersList ? "0.875rem" : "1rem", // Smaller font size
                        height: sharedCalUsersList ? "42px" : "45px", // Reduced height
                        paddingLeft: sharedCalUsersList ? "12px" : "Opx", // Add space for the icon
                    },
                    sx: sharedCalUsersList
                        ? {
                              borderRadius: "10px",
                              padding: "0px",
                              paddingRight: "20px",
                              "& .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "#ccc",
                              },
                              "&:hover .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "#aaa",
                              },
                              "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                  {
                                      borderColor: "#000",
                                  },
                          }
                        : inputStyles, // <- Closing brace was missing before this line
                }}
                InputLabelProps={{
                    style: {
                        fontSize: sharedCalUsersList ? "0.875rem" : "inherit", // Smaller label font size
                        marginLeft: sharedCalUsersList ? "12px" : "Opx",
                        marginTop: "1px",
                    },
                }}
                size="small" // This also helps reduce the overall size
            />

            {sharedCalUsersList && (
                <div className="absolute pl-2 top-1/2 -translate-y-1/2 text-sm text-gray-500 pointer-events-none">
                    <FiUsers />
                </div>
            )}

            {showSuggestions && (
                <div
                    className={`absolute w-full bg-white border border-slate-300 rounded-lg shadow-lg max-h-60 overflow-y-auto z-20 text-left
					top-full md:mt-2
					top-auto md:bottom-full mb-2`}
                >
                    {filteredUsers.length > 0 ? (
                        filteredUsers.map((el) => (
                            <div
                                key={usersList ? el.user_id : el.user.user_id}
                                onMouseDown={(e) => {
                                    e.preventDefault();
                                    usersList
                                        ? selectUser(el.user_id)
                                        : selectUser(el.user.user_id);
                                }}
                                className="cursor-pointer px-2 py-1 hover:bg-slate-100"
                            >
                                <div className="flex flex-row items-end">
                                    <div className="text-base text-black w-2/3">
                                        {usersList
                                            ? el.first_name
                                            : el.user.first_name}{" "}
                                        {usersList
                                            ? el.last_name
                                            : el.user.last_name}
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="px-3 py-2">Pas de résultat</div>
                    )}
                </div>
            )}
        </div>
    );
};

export default UserSearch;
